import { type VariantProps, cva } from 'class-variance-authority';
import * as React from 'react';

import { cn } from '@/shared/utils/index';

const badgeVariants = cva(
  'inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-zinc-900 focus:ring-offset-2 focus:ring-offset-white',
  {
    variants: {
      variant: {
        default: 'border-transparent bg-zinc-900 text-neutral-50 hover:bg-zinc-900/80',
        secondary: 'border-transparent bg-zinc-100 text-zinc-900 hover:bg-zinc-100/80',
        destructive: 'border-transparent bg-red-600 text-red-50 hover:bg-red-600/80',
        outline: 'bg-white border-zinc-200 text-zinc-900 hover:bg-zinc-50',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  },
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return <div className={cn(badgeVariants({ variant }), className)} {...props} />;
}

export { Badge, badgeVariants };
